import { createComponent } from '@carvana/merch-components';
import { TertiaryButton } from '@/common/Button';

export const LightCtaButton = createComponent(TertiaryButton, {
  className: 'mx-auto bg-white text-blue-6 hover:text-blue-3 active:text-blue-2'
});

export const DarkCtaButton = createComponent(TertiaryButton, {
  className: `mx-auto bg-blue-2 text-center text-white hover:bg-blue-3 active:bg-blue-4`
});

export const GhostCtaButton = createComponent(TertiaryButton, {
  className: `
    self-center
    border
    border-blue-2
    bg-white
    text-blue-2
    hover:bg-blue-3
    hover:text-white
    active:bg-blue-4
    active:text-white
  `
});
